<template>
  <div class="roomsGrid">
    <RoomPanel v-for="room in allRooms" :key="room.id" :room="room" />
  </div>
</template>

<script>
import RoomPanel from '@/components/RoomPanel.vue'

export default {
  components: { RoomPanel },
  data() {
    return { specificRooms: ['1.025', '1.025A', '1.025B'] }
  },
  computed: {
    allRooms() {
      const { rooms } = this.$store.state

      if (this.specificRooms.length === 0) return rooms

      return this.specificRooms
        .map(roomName => rooms.find(r => r.name === roomName))
        .filter(room => room)
    }
  },
  mounted() {
    if (this.$route.query.rooms) {
      this.specificRooms = this.$route.query.rooms.split(',')
    }
  }
}
</script>

<style lang="scss" scoped>
.roomsGrid {
  width: 100vw;
  height: 100vh;

  display: flex;

  .roomPanel {
    flex: 1;
  }
}

@include mobile {
  .roomsGrid {
    flex-direction: column;
  }
}

@include tablet {
  .roomPanel {
    width: percentage(1 / 3);
  }
}
</style>
